import React from 'react';
import FormField from './FormField';

const AppFormField = (props) => <FormField {...props} />;

export default AppFormField;